import { toast } from "react-toastify";

export const getEmbededYoutubeUrl = (url) => {
	const regex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
	const match = url.match(regex);
	const videoId = match ? match[1] : null;

	return `https://www.youtube.com/embed/${videoId}`;
};

export const scrollTop = () => {
	window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};

export const toastNotify = (type, message) => {
	if (type == "error") {
		toast.error(message);
	} else {
		toast.success(message);
	}
};
